import Result from "@/core/common/Result";

export type ObterMensagemBoasVindasResponse = {
  podeVisualizarMensagemBoasVindas: boolean;
};

export interface IObterMensagemBoasVindasGateway {
  getMensagemBoasVindas(): Promise<Result<ObterMensagemBoasVindasResponse>>;
}

export const obterMensagemBoasVindasGatewayDI =
  "obterMensagemBoasVindasGatewayDI";
